@if (matcher$ | async; as matcher) {
  <div class="layout-col">
    <app-material-matcher-detail class="flex" [matcher]="matcher.materialMatcher">
    </app-material-matcher-detail>
    <elder-label-input
      name="allowedNames"
      label="{{ 'materials.allowed-names' | translate }}"
      [(value)]="matcher.allowedNames"
    >
    </elder-label-input>
  </div>
}
